import { atom } from "recoil";

export const currentTemplateAtom = atom<{ uid: string }>({
  key: "SMS_templates_atom",
  default: {
    uid: "demo",
  },
});
